/**
 * PURPOSE: User-facing copy for the fatal bootstrap failures that leave the user on <BootstrapError />.
 */

export const MISSING_DEAL_XG_ID_MESSAGE = '"dealXgId" is not available.';
export const UNAUTHORIZED_DEALERSHIP_MESSAGE = 'Unauthorized: Access to this dealership is forbidden.';
export const DEAL_LOAD_FAILED_MESSAGE = 'Unable to load the deal for this link.';
